export default __webpack_public_path__ + "static/media/maldives-travel-tips-cover (1).4207ea89.jpg";